/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaStudenteDTO } from './servizio-mensa-studente-dto';


export interface ServizioMensaFratelloDTO { 
    visibile?: boolean;
    studente?: ServizioMensaStudenteDTO;
}

